import React from "react";
import { useDispatch, useSelector } from "react-redux";

import ConfirmationDialog from "../common/ConfirmationDialog";
import UserEdit from "./UserEdit";
import UsersList from "./UsersList";
import { usersActions, fetchUsers, deleteUser } from "../../store/users-slice";

const Users = (props) => {
  const users = useSelector((state) => state.users.users);
  const selectedUser = useSelector((state) => state.users.selected);
  const isLoading = useSelector((state) => state.ui.usersLoading);
  const dispatch = useDispatch();

  const [isEditDialogOpen, setIsEditDialogOpen] = React.useState(false);
  const [isRemove, setIsRemove] = React.useState(false);

  React.useEffect(() => {
    dispatch(fetchUsers());
  }, [dispatch]);

  const rowSelectedHandler = (event) => dispatch(usersActions.setSelected(event.data.id));

  const editUserHandler = () => {
    setIsEditDialogOpen(true);
  };
  const addUserHandler = () => {
    setIsEditDialogOpen(true);
  };

  const deleteUserHandler = () => {
    dispatch(deleteUser(selectedUser.id))
  };

  return (    
    <>
      <UserEdit
        user={selectedUser}
        open={isEditDialogOpen}
        onClose={() => setIsEditDialogOpen(false)}
      />
      <ConfirmationDialog
        open={isRemove}
        onClose={() => setIsRemove(false)}
        onOk={deleteUserHandler}
        caption="Please confirm?"
        text="This will deactivate this user, denaying service access. Are You sure?"
      />
      <UsersList
        users={users}
        isLoading={isLoading}
        density={props.density}
        onRowSelected={rowSelectedHandler}
        onAdd={addUserHandler}
        isAddDisabled={true}
        onEdit={editUserHandler}
        isEditDisabled={selectedUser == null}
        onDelete={() => setIsRemove(true)}
        isDeleteDisabled={selectedUser == null}
      />
    </>
  );
};

export default Users;
